import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=5c9eb49c&scoped=true&"
import script from "./Quiz.vue?vue&type=script&lang=js&"
export * from "./Quiz.vue?vue&type=script&lang=js&"
import style0 from "../../../public/assets/css/general-front-css.css?vue&type=style&index=0&id=5c9eb49c&scoped=true&lang=css&"
import style1 from "./Quiz.vue?vue&type=style&index=1&id=5c9eb49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9eb49c",
  null
  
)

export default component.exports